import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter } from "@chakra-ui/react";

interface ModalWarningProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    message: string;
}

const ModalWarning = ({ isOpen, onClose, title, message }: ModalWarningProps) => {
    return (
        <Modal onClose={onClose} isOpen={isOpen} isCentered>
            <ModalOverlay />
            <ModalContent borderRadius={15} padding={5}>
                <ModalHeader textAlign="center">{title}</ModalHeader>
                <ModalCloseButton onClick={onClose} _focus={{ outline: 'none', boxShadow: 'none' }} />
                <ModalBody textAlign="center" marginTop={-5}>
                    {message}
                </ModalBody>
                <ModalFooter style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button onClick={onClose} bgColor="#F79009" color="white">
                        OK
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ModalWarning;